// extracted by mini-css-extract-plugin
module.exports = {"subMetric":"styles-module__subMetric___2vfn5","span":"styles-module__span___3KZVY"};